import { Component, OnInit } from '@angular/core';
import { TitleService } from './_services/title.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'app';

  constructor(private titleService: TitleService) {}

  ngOnInit(): void {
    // Initialize the title service to handle route-based title updates
    this.titleService.init();
  }
}
